module.exports = __webpack_public_path__ + "img/cz134902dn.a20d0577.jpeg";